import { gql } from "@apollo/client";

export const GET_INSTITUCIONES_BY_DELEGACION_USUARIO = gql`
query GetInstitucionesByDelegacion (
    $idDelegacion: Int!
) {
    institucionesByDelegacionAndUsuario (idDelegacion: $idDelegacion)
        {
            cod_Institucion,
            nombre,
            domicilio
        }
}`;